module.exports = {"id":"203890","name":"Šime Vrsaljko","rating":"80","photo":"./data/images/photos/3/203890.png","club":{"name":"Atlético Madrid","logo":"./data/images/clubs/AtleticoMadrid.png"},"positions":["DD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SimeVrsaljko0.json
// module id = 3960
// module chunks = 0